var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 59,
    viewBox: "0 0 71 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8004 45.6554C34.2011 46.1777 33.3083 46.1777 32.709 45.6554L28.2221 41.7448C27.1924 40.8473 25.5849 41.5787 25.5849 42.9446V57.0826C25.5849 57.9615 24.8724 58.6741 23.9934 58.6741H2.41964C1.54067 58.6741 0.828125 57.9615 0.828125 57.0826V2.49971C0.828125 1.62074 1.54067 0.908203 2.41963 0.908203H25.9403C26.5334 0.908203 27.0772 1.23797 27.3515 1.76383L32.5086 11.6533C33.1035 12.7941 34.736 12.7941 35.3309 11.6533L40.488 1.76383C40.7622 1.23797 41.306 0.908203 41.8991 0.908203H68.8857C69.7647 0.908203 70.4773 1.62075 70.4773 2.49971V57.0826C70.4773 57.9615 69.7647 58.6741 68.8857 58.6741H43.5159C42.637 58.6741 41.9244 57.9615 41.9244 57.0826V42.9446C41.9244 41.5787 40.3169 40.8473 39.2872 41.7448L34.8004 45.6554Z",
    fill: "#165E24",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchaLogo);
export default __webpack_public_path__ + "static/media/matcha-logo.691a90fc608ca69daca747e54724bc6e.svg";
export { ForwardRef as ReactComponent };